<template>
<div class="diandian-home">
    <div class="dh-nav" :class="{'nav-fixed':isFixed}"></div>
    <div class="dh-banner">
        <swiper :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide class="dh-1">
                I'm Slide 1
            </swiper-slide>
            <swiper-slide class="dh-2">
                I'm Slide 2
                <canvas ref="waves" width="500px" height="500px" id="box"></canvas>
            </swiper-slide>
            <swiper-slide class="dh-3">
                I'm Slide 3
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
    </div>
</div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data() {
        const _vue = this;
        return {
            isFixed: false,
            swiperOption: {
                direction: 'vertical',
                mousewheel: true,
                touchRatio: 0.5,
                resistanceRatio: 0,
                // autoplay: {
                //     delay: 15000,
                //     // stopOnLastSlide: false,
                //     // disableOnInteraction: true,
                // },
                // loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function(e) {
                        if (this.activeIndex == 1) {
                            _vue.wavesHandle()
                        }
                    }
                }
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev'
                // }
            }
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    created() {
        document.title = '点点';
        this.swiperOption.height = document.documentElement.clientHeight || document.body.clientHeight
    },
    mounted() {
        // this.swiper.slideTo(1, 1000, false);
        console.log(this.swiper);
        this.resetHeight()
        this.scrollHandle()

        





    },
    methods: {
        resetHeight() {
            var clienHeight = document.documentElement.clientHeight || document.body.clientHeight
            this.$refs.mySwiper.$el.style.height = clienHeight + 'px'
        },
        scrollHandle() {
            window.addEventListener('scroll', () => {
                var nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;
                console.log(nowScrollTop);
                if (nowScrollTop > 0) {
                    this.isFixed = true
                } else {
                    this.isFixed = false
                }
            }, false)
        },
        wavesHandle() {
            var oWaves = this.$refs.waves;
            var ctx = oWaves.getContext('2d');
            var w, h;
            oWaves.width = w = document.documentElement.clientWidth;
            oWaves.height = h = document.documentElement.clientHeight;

            //动画波浪
            var timer = null;
            var x = 0;
            var y = 0;

            var mind = 0;
            var lastY = 0;
            var maxHeight = 200;
            var wavesHeight = maxHeight;

            var wavesJson = [{
                    swing: 50,
                    speedX: 0.7,
                    x: 0,
                    y: 0,
                    waves: 280,
                    color: 'rgba(196, 146, 194, 0.6)'
                },
                {
                    swing: 30,
                    speedX: 2,
                    x: 0,
                    y: 0,
                    waves: 230,
                    color: 'rgba(228, 225, 154, 0.6)'
                },
                {
                    swing: 45,
                    speedX: 1.5,
                    x: 0,
                    y: 0,
                    waves: 150,
                    color: 'rgba(114, 163, 201, 0.6)'
                }
            ];

            //通过位移来轮播
            //初始高度
            //ctx.translate(0,200);
            function runWaves() {
                //清除画布
                ctx.clearRect(0, 0, oWaves.offsetWidth * 2, oWaves.offsetHeight);
                //波纹
                maxHeight *= 0.975;
                maxHeight < 1 ? maxHeight = 0 : maxHeight;
                var nowHeight = wavesHeight - maxHeight;
                var scale = nowHeight / wavesHeight;
                //高度少10
                // var bgWavesHeight = h - nowHeight + 10;

                mind++;
                var mould = Math.PI / 180 * (mind);
                // var sin = Math.sin(mould) * swing;
                // var cos = Math.cos(mould) * swing;

                for (var i = 0; i < wavesJson.length; i++) {
                    var s = wavesJson[i];
                    //破浪速度
                    s.x += s.speedX;
                    if (s.x >= w / 2) {
                        //console.log('一半')
                        s.x = 0;
                    }
                    //变化幅度
                    var sin = Math.sin(mould) * s.swing;
                    var cos = Math.cos(mould) * s.swing;
                    var wavesNum = s.waves * scale + cos;
                    var cHeight = h - nowHeight + sin;
                    // console.log(wavesNum,'wavesNum');

                    //canvas
                    ctx.beginPath();
                    ctx.moveTo(0 - s.x, cHeight);
                    ctx.bezierCurveTo(w / 4 - s.x, cHeight - wavesNum, w / 4 - s.x, cHeight + wavesNum, w / 2 - s.x, cHeight);
                    ctx.bezierCurveTo(w / 4 * 3 - s.x, cHeight - wavesNum, w / 4 * 3 - s.x, cHeight + wavesNum, w - s.x, cHeight);
                    ctx.bezierCurveTo(w + w / 4 - s.x, cHeight - wavesNum, w + w / 4 - s.x, cHeight + wavesNum, w + w / 2 - s.x, cHeight);
                    //底部 h*2
                    ctx.lineTo(w + w / 2 - s.x, h);
                    ctx.lineTo(0 - s.x, h);
                    ctx.closePath();

                    //渐变
                    //        var lgd=ctx.createLinearGradient(w/2,h,w/2,cHeight);
                    //        lgd.addColorStop(0,'rgba(95,184,255,0.75)');
                    //        lgd.addColorStop(0.75,'rgba(142,210,255,0.75)');
                    //        lgd.addColorStop(1,'rgba(142,210,255,0.75)');
                    //#5fb8ff
                    ctx.fillStyle = s.color;
                    ctx.fill();
                }


                //cancelAnimationFrame(timer);
                timer = requestAnimationFrame(runWaves);
            }
            runWaves();
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Hello.vue?7a5e8150